import "./loginForm.scss";
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "src/context/AuthProvider";
import { useTranslation } from "react-i18next";
import { APP_INFO } from "src/config/appInfo";
import LanguageSelect from "src/components/LanguageSelect/LanguageSelect";
import { PasswordInput } from "src/components/PasswordInput/PasswordInput";

export default function LoginForm() {
    const navigate = useNavigate();
    const { login } = useAuth();
    const { t } = useTranslation();

    const [praxis, setPraxis] = useState("");
    const [user, setUser] = useState("");
    const [pass, setPass] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [capsLock, setCapsLock] = useState(false);

    const handleLogin = async () => {
        setError("");
        setLoading(true);
        const err = await login(praxis, user, pass);
        setLoading(false);

        if (!err) {
            navigate("/main");
        } else if (err === "EMAIL_NOT_VERIFIED") {
            setError(t("login.emailNotVerified"));
        } else if (err.startsWith("ACCOUNT_LOCKED:")) {
            const until = new Date(err.slice("ACCOUNT_LOCKED:".length));
            setError(t("login.accountLocked", { time: until.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) }));
        } else if (err.toLowerCase().includes("too many")) {
            setError(t("login.tooManyAttempts", { defaultValue: "Too many login attempts. Please wait 15 minutes and try again." }));
        } else {
            setError(t("login.invalidCredentials"));
        }
    };

    return (
        <div className="login-card">
            <LanguageSelect />
            <div className="login-header">
                <div className="login-logo">
                    <img src="/medinvoice-logo.png" alt={APP_INFO.appName} className="login-brand-logo" />
                </div>
                <div className="login-title">{t("login.welcome")}</div>
                <div className="login-subtitle">
                    {t("login.subtitle")}
                </div>
            </div>

            <form
                onSubmit={(e) => e.preventDefault()}
                autoComplete="off"
                onKeyUp={(e) => setCapsLock(e.getModifierState("CapsLock"))}
            >
                <div className="form-group">
                    <label htmlFor="login-praxis">{t("login.praxisId")}</label>
                    <input
                        id="login-praxis"
                        name="praxis"
                        type="text"
                        placeholder={t("login.praxisIdPlaceholder")}
                        onChange={(e) => setPraxis(e.target.value)}
                        onKeyUp={(e) =>
                            e.key === "Enter" ? handleLogin() : null
                        }
                        autoFocus
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="login-email">{t("login.email")}</label>
                    <input
                        id="login-email"
                        name="email"
                        type="email"
                        placeholder={t("login.emailPlaceholder")}
                        onChange={(e) => setUser(e.target.value)}
                        onKeyUp={(e) =>
                            e.key === "Enter" ? handleLogin() : null
                        }
                    />
                </div>

                <div className="form-group">
                    <div className="login-field-header">
                        <label htmlFor="login-password">{t("login.password")}</label>
                        <Link to="/forgot-password" className="login-forgot-link">
                            {t("login.forgotPassword")}
                        </Link>
                    </div>
                    <PasswordInput
                        id="login-password"
                        name="password"
                        placeholder={t("login.password")}
                        value={pass}
                        onChange={(e) => setPass(e.target.value)}
                        onKeyUp={(e) => (e.key === "Enter" ? handleLogin() : null)}
                        autoComplete="current-password"
                    />
                </div>

                {capsLock && <div className="login-capslock">{t("login.capsLock")}</div>}

                <div className="login-error">{error}</div>
                <button
                    type="button"
                    className="btn-primary"
                    onClick={handleLogin}
                    disabled={loading}
                >
                    {loading ? <span className="btn-spinner" /> : t("login.signIn")}
                </button>
            </form>

            <div className="login-register">
                {t("login.noAccount")}{" "}
                <Link to="/register" className="login-contact-link">{t("login.register")}</Link>
            </div>

            <div className="login-contact">
                {t("login.questions")}{" "}
                <span className="login-contact-link">{APP_INFO.email}</span>
            </div>
        </div>
    );
}
